"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leftPad = leftPad;
exports.getColorBySeverity = getColorBySeverity;
exports.capitalize = capitalize;
const chalk = require("chalk");
function leftPad(text, padding = 4) {
    return padding <= 0 ? text : ' '.repeat(padding) + text;
}
function getColorBySeverity(severity) {
    switch (severity) {
        case 'low':
            return chalk.blueBright;
        case 'medium':
            return chalk.yellowBright;
        case 'high':
            return chalk.redBright;
        case 'critical':
            return chalk.magentaBright;
        default:
            return chalk.whiteBright;
    }
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
//# sourceMappingURL=common.js.map